import { normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["ErrorMessage"], {
        id: $setup.formMessageId,
        "data-slot": "form-message",
        as: "p",
        name: $setup.toValue($setup.name),
        class: _normalizeClass($setup.cn('text-destructive text-sm', $setup.props.class))
    }, null, 8 /* PROPS */, ["id", "name", "class"]));
}
